import { CanActivate, Router } from '@angular/router';
import { Injectable } from "@angular/core";
import { LoginService } from "../login/login.service";

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(private readonly loginService: LoginService, private readonly router: Router) {
  }

  async canActivate(): Promise<boolean> {
    if (this.loginService.isAdmin()) {
      return true;
    }

    await this.router.navigate(['/lead-pool']);
    return false;
  }
}
